import { CloseIcon } from "@chakra-ui/icons";
import { Badge } from "@chakra-ui/layout";

const UserBadgeItem = ({ user, handleFunction, admin }) => {
  return (
    <Badge
      px={3}
      py={1.5}
      borderRadius="full"
      m={1}
      mb={2}
      variant="solid"
      fontSize={12}
      fontWeight={500}
      textTransform="none"
      letterSpacing="0.02em"
      bg="#243D27"
      color="#F2DFB6"
      cursor="pointer"
      transition="all 0.15s ease"
      _hover={{ bg: "#8D414B" }}
      onClick={handleFunction}
    >
      {user.name}
      {admin === user._id && <span> · админ</span>}
      <CloseIcon pl={1.5} boxSize="11px" />
    </Badge>
  );
};

export default UserBadgeItem;
